import {Component, OnInit, Input, ViewContainerRef, ComponentFactoryResolver} from "@angular/core";
import {ViewComponent} from './view.component';
import {RowDynamicComponent} from '../../models/row-dynamic-component.model';
import {TableBodyRowCell} from '../../models/table-body-row-cell.model';
import {TableBodyRow} from '../../models/table-body-row.model';

@Component({
  selector: 'view-row-dynamic-component',
  template: '',
})
export class RowDynamicComponentComponent implements OnInit {
  @Input() public component: any;
  @Input() public cell: TableBodyRowCell;
  @Input() public row: TableBodyRow;
  @Input() public viewComponent: ViewComponent;
  @Input() public values: any;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {}

  public ngOnInit() {
    const factoryClass = this.component;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory<RowDynamicComponent>(
      factoryClass
    );
    const componentRef = this.viewContainerRef.createComponent<RowDynamicComponent>(
      componentFactory
    );
    componentRef.instance.cell = this.cell;
    componentRef.instance.row = this.row;
    componentRef.instance.viewComponent = this.viewComponent;
    componentRef.instance.values = this.values;

    componentRef.changeDetectorRef.detectChanges();
  }
}
